import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesStaff } from "../../constants";

export const requestRestoreStaffManager = async (id: string): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesStaff.Admin, id, ApiRoutesStaff.Restore)
  );
};
